import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton/styledButton';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';

export const Container = styled(GridContainer)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 1024px) {
        z-index: 1;
    }
    @media (max-width: 680px) {
        display: block;
    }
`;

export const Content = styled.div`
    display: block;
    width: 928px;
    @media (max-width: 1599px) {
        width: 775px;
    }
    @media (max-width: 1279px) {
        width: 500px;
    }
    @media (max-width: 1024px) {
        width: 400px;
    }
    @media (max-width: 680px) {
        width: 100%;
    }
`;

export const Button = styled(StyledButton)`
    width: 100%;
    @media (min-width: 859px) {
        max-width: 250px;
    }
`;

export const Title = styled.h1`
    font-family: ${FONTS.light};
    font-weight: 300;
    font-style: normal;
    font-size: 60px;
    line-height: 72px;
    width: 100%;
    max-width: 928px;
    margin: 0 0 16px 0;
    @media (max-width: 1599px) {
        font-size: 50px;
        line-height: 62px;
    }
    @media (max-width: 1279px) {
        font-size: 32px;
        line-height: 40px;
        margin-bottom: 16px;
        margin-top: 8px;
    }
    @media (max-width: 530px) {
        width: 100%;
        font-size: 24px;
        line-height: 32px;
    }
`;

export const SubTitle = styled.div`
    font-family: ${FONTS.light};
    font-size: 16px;
    line-height: 20px;
    font-weight: normal;    
    color: ${COLORS.grey};
    padding-bottom: 16px;
`;

export const Text = styled.span`
    font-family: ${FONTS.light};
    font-size: 26px;
    line-height: 40px;
    width: 100%;
    max-width: 928px;
    display: flex;
    padding-bottom: 16px;
    @media (max-width: 1599px) {
        font-size: 28px;
        line-height: 36px;
        max-width: 650px;
    }
    @media (max-width: 1279px) {
        font-size: 22px;
        line-height: 30px;
        max-width: 100%;
    }
    @media (max-width: 530px) {
        font-size: 16px;
        line-height: 24px;
    }
`;

export const Red = styled.span`
    color: ${COLORS.lightRed}
`;

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    justify-content: flex-start;
    align-items: center;    
    padding: 100px 0;
    background: ${COLORS.black};
    color: ${COLORS.white};
    @media (max-width: 1599px) {
        padding: 70px 0;
    }
    @media (max-width: 1023px) {
        padding: 50px 0;
    }
    @media (max-width: 530px) {
        min-height: 0;
        padding: 50px 0 80px;
        overflow: hidden;
    }
`;

export const BackgroundImage = styled.svg`
    display: block;
    position: absolute;
    z-index: 0;
    height: 100%;
    top: 0;
    right: -1%;
    @media (max-width: 1599px) {
        right: -4%;
    }
    @media (max-width: 1281px) {
        right: -14%;
    }
    @media (max-width: 1170px) {
        right: -22%;
    }
    @media (max-width: 1023px) {
        right: -29%;
    }
    @media (max-width: 530px) {
        width: 100%;
        height: 100%;
        bottom: -27%;
        top: unset;
        right: -45%;
    }
`;
